import React from 'react';

import { SideMobileMenuButton } from './SideMobileMenuButton';

const upperMobileMenuButtons = [
  {
    name: 'Start',
    link: '/welcomeBack',
  },
  {
    name: 'Preferences',
    link: '/preferences',
  },
  {
    name: 'Tour',
    link: '/tour',
  },
  {
    name: 'Password',
    link: '/updatePws',
  },
];

const lowerMobileMenuButtons = [
  {
    name: 'Feedback',
    link: '/feedback',
  },
  {
    name: 'Logout',
    link: '/logout',
  },
];

export const SideMobileMenuContent = () => {
  return (
    <div className="flex h-screen flex-col justify-between overflow-y-hidden">
      <div className="flex flex-col gap-[13px] px-[9px] pt-[58px]">
        {upperMobileMenuButtons.map((btn) => {
          return <SideMobileMenuButton key={btn.name} sideMenuButtonAttributes={btn} />;
        })}
      </div>
      <div className="mb-14 flex flex-col gap-[13px] px-[9px]">
        {lowerMobileMenuButtons.map((btn) => {
          return <SideMobileMenuButton key={btn.name} sideMenuButtonAttributes={btn} />;
        })}
      </div>
    </div>
  );
};
